const selectors = {
  solution: "[data-solution]",
  solutionDialog: "[data-solution-dialog]",
};

const initSolution = (solution) => {
  const solutionDialog = solution.querySelector(selectors.solutionDialog);

  solution.addEventListener("click", () => {
    solutionDialog.showModal();
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const solutions = document.querySelectorAll(selectors.solution);

    solutions?.forEach(initSolution);
  },
  {
    once: true,
  }
);
